import axios from "axios";
import {AUTH_EMAIL_CODE_STOP_PATH} from "api/endpointPaths.mjs";
import {serverMessage} from "utils/ErrorUtils";

/**
 * Redeems the reminder's stop link (api-service#1019). This module is deliberately independent of
 * React: the outcome vocabulary is decided here, and the modal only chooses a sentence for it.
 */

export type StopRemindersOutcome =
	/**
	 * No further reminder is sent to the unfinished account: it was deleted, or kept because a sender saved its address
	 * as a contact, with its reminders stopped (kitecorp/transferify-api-service#2741).
	 */
	| {kind: "stopped"}
	/** The link verified but there was nothing left to stop: the signup was finished, or already gone. */
	| {kind: "nothingToStop"}
	/** The link did not verify (malformed, tampered, expired). `message` is the api's own explanation. */
	| {kind: "refused"; message: string | null};

export async function stopReminders(token: string): Promise<StopRemindersOutcome> {
	try {
		// The token travels as a query parameter, never a body: the same URL is the RFC 8058 endpoint a
		// mailbox provider posts to, and it reads the token from the URL it was handed in the header.
		const response = await axios.post<{stopped: boolean}>(
			`${process.env.REACT_APP_URL}${AUTH_EMAIL_CODE_STOP_PATH}`,
			null,
			{params: {token}},
		);
		return response.data.stopped ? {kind: "stopped"} : {kind: "nothingToStop"};
	} catch (thrown) {
		return {kind: "refused", message: serverMessage(thrown)};
	}
}
